import ConstituentType from '@/constants/ConstituentType';

export const isPersonConstituentType = (constituent) =>
  constituent?.constituentType !== ConstituentType.ORG;

export const getPrimaryEmail = (emails = []) =>
  emails.length
    ? (emails.find(({ primary }) => primary) || emails[0])?.email
    : null;

export const getPrimaryPhoneNumber = (phones = []) =>
  phones.length
    ? (phones.find(({ primary }) => primary) || phones[0])?.number
    : null;

export const getPrimaryPhoneObject = (phones = []) =>
  phones.length ? phones.find(({ primary }) => primary) || phones[0] : null;
